module.exports = __webpack_public_path__ + "static/img/z.shield-1.00f25c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/z.shield-1.svg
// module id = VHik
// module chunks = 1